import { getActivatedRules } from "./paymentHelper/paymentHelper.ts";

export const getCouponDiscount = (tickets: any[], coupon: any | undefined | null = null) => {
    let couponDiscount = 0;

    if (coupon) {
        let useDiscount = true;

        for (const ttId of coupon.ticketTypeIds) {
            if (tickets.filter(t => t.ticketTemplateId == ttId).length == 0) {
                useDiscount = false;
                break;
            }
        }

        if (useDiscount) {
            for (const ticket of tickets) {
                if (!coupon.ticketTypeIds || coupon.ticketTypeIds.length === 0) {
                    couponDiscount += coupon.fixedDiscount;
                }
                else if (coupon.ticketTypeIds.filter(id => id == ticket.ticketTemplateId) > 0) {
                    couponDiscount += coupon.fixedDiscount;
                }
            }
        }
    }

    return couponDiscount
}

export const getPriceInternal = (tickets: any[], ticketTemplates: any[], coupon: any | undefined | null = null) => {
    let price = 0;

    price = tickets.reduce((a, ticket) => {
        return a + ticket.getPrice();
    }, 0);

    return price - getCouponDiscount(tickets, coupon);
}

export const getPrice = (tickets: any[], ticketTemplates: any[], coupon: any, manualDiscount = 0): number => {
    const price = getPriceInternal(tickets, ticketTemplates, coupon) - manualDiscount;

    return +(price > 0 ? price : 0).toFixed(2)
}

export const applyDiscounts = (tickets: any[], ticketTemplates: any[]) => {
    const activatedRules = getActivatedRules(tickets, ticketTemplates);

    tickets.map(t => t.rules = []);

    for (const rule of activatedRules) {
        for (const ticket of tickets.filter(t => t.ticketTemplateId === rule.ticketTemplateId)) {
            if (!ticket.rules) {
                ticket.rules = [];
            }

            ticket.rules.push(rule);
        }
    }
}

interface IFeeModel {
    rate: number,
    fixedByPosition: number,
    fixedByOrder: number,
}

export const getAdministrativeFee = (tickets: any[], fee: IFeeModel, ticketTemplates: any[], coupon: any, manualDiscount = 0) => {
    return tickets.length * fee.fixedByPosition + getPrice(tickets, ticketTemplates, coupon, manualDiscount) * fee.rate + fee.fixedByOrder;
}

export const getProcessingFee = (tickets: any[], fee: IFeeModel, ticketTemplates: any[], coupon: any, manualDiscount = 0) => {
    if (!fee) {
        return 0;
    }

    return tickets.length * fee.fixedByPosition + getPrice(tickets, ticketTemplates, coupon, manualDiscount) * fee.rate + fee.fixedByOrder;
}

export const getTotalPaymentAmount = (tickets: any[], eventInfo: any, paymentMethodFee: any = null, coupon: any = null) => {
    const price = getPrice(tickets, eventInfo.ticketTemplates, coupon);
    const administrativeFee = getAdministrativeFee(tickets, eventInfo.fee, eventInfo.ticketTemplates, coupon, 0);

    const processingFee = getProcessingFee(tickets, paymentMethodFee, eventInfo.ticketTemplates, coupon, 0);

    return {
        total: price + administrativeFee + processingFee,
        price,
        administrativeFee,
        processingFee,
    }
}